<template>
  <div id="wrapper">
    <Nav :message="message" />
    <Schedule />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import Schedule from '@/components/Schedule.vue'

export default {
  name: 'my-schedule',
  props: ['message'],
  components: {
    Nav,
    Schedule
  }
}
</script>